// extracted by mini-css-extract-plugin
module.exports = {"title":"_3_JfC","tryAgain":"Jq0JX","btn":"_3ea-j"};